"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-24 15:01:27
 * @LastEditTime: 2022-02-22 11:34:47
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\constant\chart\tooltip.ts
 */
exports.default = {
    default: {
        show: true,
        backgroundColor: "#ffffff",
        borderColor: "#F1F3F6",
        borderWidth: 1,
        padding: 12,
        extraCssText: "box-shadow: 0px 0px 8px 2px rgba(200, 216, 229, 0.24)",
        textStyle: {
            color: "#4E5969"
        }
    },
    normal: {
        show: true,
        backgroundColor: "#ffffff",
        borderColor: "#F1F3F6",
        borderWidth: 1,
        padding: 12,
        extraCssText: "box-shadow: 0px 0px 8px 2px rgba(200, 216, 229, 0.24)",
        textStyle: {
            color: "#4E5969"
        },
        formatter: function (params) {
            if (!Array.isArray(params)) {
                if (params.seriesType === "heatmap") {
                    params.value = params.data[2];
                    params.seriesName = params.data[1];
                }
                params.axisValue = params.name;
                params = [params];
            }
            var result = "<div style=\"padding:0;font-size: 14px;color: #86909C;margin-bottom:4px;\">" + params[0].axisValue + "</div>";
            params.map(function (item) {
                var mark = "";
                if (Array.isArray(item.value)) {
                    item.value = item.value[1];
                }
                mark = "<span style=\"padding-right:4px;\">" + item.marker + "</span>";
                result += "<div style=\"padding:4px 0;font-size: 14px;\">" + mark + "\n                <span style=\"display:inline-block;text-align:left;padding:0 0 0 0;width:114px;color: #4E5969;\">" + item.seriesName + "</span>\n                <span style=\"color: #1D2129;font-weight: 550;font-family: DINBold;\">" + item.value + "</span></div>";
            });
            return result;
        }
    }
};
//# sourceMappingURL=tooltip.js.map